"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSetGovernanceConfig = void 0;
var web3_js_1 = require("@solana/web3.js");
var instructions_1 = require("./instructions");
var serialisation_1 = require("./serialisation");
var borsh_1 = require("borsh");
function createSetGovernanceConfig(programId, programVersion, governance, governanceConfig) {
    var args = new instructions_1.SetGovernanceConfigArgs({ config: governanceConfig });
    var data = Buffer.from((0, borsh_1.serialize)((0, serialisation_1.getGovernanceInstructionSchema)(programVersion), args));
    var keys = [
        {
            pubkey: governance,
            isWritable: true,
            isSigner: true,
        },
    ];
    return new web3_js_1.TransactionInstruction({
        keys: keys,
        programId: programId,
        data: data,
    });
}
exports.createSetGovernanceConfig = createSetGovernanceConfig;
//# sourceMappingURL=createSetGovernanceConfig.js.map